// extracted by mini-css-extract-plugin
module.exports = {"circle":"third_circle__AtUWZ","gasfee":"third_gasfee__AXnKj","btnContainer":"third_btnContainer__TSkdx","button":"third_button__aQkEz","slippageWarn":"third_slippageWarn__qS8w3"};